import {
    VI_SUCCESS,
    VI_FAIL,
    SET_MESSAGE
} from "./type";

import ViewInstance from "../services/viewinstance.service"

export const getLanding = (groupGuid, languageID) => (dispatch) => {
  
    return ViewInstance.getLanding(groupGuid, languageID).then(
      (data) => {
       
        dispatch({
          type: VI_SUCCESS,
          payload: {viewInstance: data.Info[0].ViewInstanceData},
        });
  
        return Promise.resolve();
      },
      (error) => {
        const message =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();
  
        dispatch({
          type: VI_FAIL,
        });
  
        dispatch({
          type: SET_MESSAGE,
          payload: message,
        });
  
        return Promise.reject();
      }
    );
  };

export const getLogout = (groupGuid, languageID) => (dispatch) => {
   
    return ViewInstance.getLogout(groupGuid, languageID).then(
      (data) => {
      
        dispatch({
          type: VI_SUCCESS,
          payload: {viewInstance: data.Info[0].ViewInstanceData},
        });
  
        return Promise.resolve();
      },
      (error) => {
        const message =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();
  
        dispatch({
          type: VI_FAIL,
        });
  
        dispatch({
          type: SET_MESSAGE,
          payload: message,
        });
  
        return Promise.reject();
      }
    );
  };

  export const getPWRequest = (groupGuid, languageID) => (dispatch) => {
    
    return ViewInstance.getPWRequest(groupGuid, languageID).then(
      (data) => {
        dispatch({
          type: VI_SUCCESS,
          payload: {viewInstance: data.Info[0].ViewInstanceData},
        });
  
        return Promise.resolve();
      },
      (error) => {
        const message =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();
  
        dispatch({
          type: VI_FAIL,
        });
  
        dispatch({
          type: SET_MESSAGE,
          payload: message,
        });
  
        return Promise.reject();
      }
    );
  };

  export const getPWReset = (pwrg) => (dispatch) => {
    
    return ViewInstance.getPWReset(pwrg).then(
      (data) => {
        dispatch({
          type: VI_SUCCESS,
          payload: {viewInstance: data.Info[0].ViewInstanceData},
        });
  
        return Promise.resolve();
      },
      (error) => {
        const message =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();
  
        dispatch({
          type: VI_FAIL,
        });
  
        dispatch({
          type: SET_MESSAGE,
          payload: message,
        });
  
        return Promise.reject();
      }
    );
  };

  export const getPWResetAuth = (auth) => (dispatch) => {
   
    return ViewInstance.getPWResetAuth(auth).then(
      (data) => {
        dispatch({
          type: VI_SUCCESS,
          payload: {viewInstance: data.Info[0].ViewInstanceData},
        });
  
        return Promise.resolve();
      },
      (error) => {
        const message =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();
  
        dispatch({
          type: VI_FAIL,
        });
  
        dispatch({
          type: SET_MESSAGE,
          payload: message,
        });
  
        return Promise.reject();
      }
    );
  };

  export const getViewInstance = (viewInstance, authToken) => (dispatch) => {
    
    return ViewInstance.getViewInstance(viewInstance, authToken).then(
      (data) => {
        
        dispatch({
          type: VI_SUCCESS,
          payload: {viewInstance: data.Info[0].ViewInstanceData, settings: data.Info[1]},
        });
  
        return Promise.resolve();
      },
      (error) => {
        const message =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();
  
        dispatch({
          type: VI_FAIL,
        });
  
        dispatch({
          type: SET_MESSAGE,
          payload: message,
        });
  
        return Promise.reject();
      }
    );
  };